<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-box-archive me-2"></i>Archiv ({{totalEntries}})</h1>
</div>

<pagination
        [hidden]="entries?.length == 0"
        [totalItems]="totalEntries"
        [itemsPerPage]="paginConfig.itemsPerPage"
        [(ngModel)]="paginConfig.page"
        (pageChanged)="listEntries($event)"
        [maxSize]="20"
        previousText="Letzte"
        nextText="Nächste">
</pagination>

<div class="table-responsive">
    <table class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th></th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.title" [class.search-active]="search.title != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th>
                <select class="form-control" [(ngModel)]="search.status" [class.search-active]="search.status != 'all'" (ngModelChange)="checkFilterAndList()">
                    <option value="all" selected="selected">Alle</option>
                    <option value="new">Neu</option>
                    <option value="in_progress">In Bearbeitung</option>
                    <option value="done">Erledigt</option>
                    <option value="cancelled">Abgesagt</option>
                </select>
            </th>
            <th></th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.customer" [class.search-active]="search.customer != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th></th>
            <th></th>
            <th>
                <select class="form-control" [(ngModel)]="search.id_department" [class.search-active]="search.id_department != 'all'" (ngModelChange)="checkFilterAndList()">
                    <option value="all" selected="selected">Alle</option>
                    <option value=" " selected="selected">Keine</option>
                    <option *ngFor="let department of departments" [ngValue]="department.id">{{department.name}}</option>
                </select>
            </th>
            <th>
                <select class="form-control" [(ngModel)]="search.id_tasktype" [class.search-active]="search.id_tasktype != 'all'" (ngModelChange)="checkFilterAndList()">
                    <option value="all" selected="selected">Alle</option>
                    <option *ngFor="let tasktype of tasktypes" [ngValue]="tasktype.id">{{tasktype.name}}</option>
                </select>
            </th>
        </tr>
        <tr>
            <th (click)="setOrder('id')">
                # <i class="fas" *ngIf="predicate == 'id'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('title')">
                Titel <i class="fas" *ngIf="predicate == 'title'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('status')">
                Status <i class="fas" *ngIf="predicate == 'status'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('created_at')">
                Erstellt am <i class="fas" *ngIf="predicate == 'created_at'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('customer')">
                Kunde <i class="fas" *ngIf="predicate == 'customer'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('contact')">
                Kontakt <i class="fas" *ngIf="predicate == 'contact'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('due_date')">
                Fälligkeit <i class="fas" *ngIf="predicate == 'due_date'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('department')">
                Abteilung <i class="fas" *ngIf="predicate == 'department'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('tasktype')">
                Typ <i class="fas" *ngIf="predicate == 'tasktype'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/task', entry.id]">
            <td>{{ entry.id }}</td>
            <td>{{ entry.title }}</td>
            <td>
                <i class="fa-solid fa-circle"
                   [class.text-danger]="entry.status == 'new'"
                   [class.text-warning]="entry.status == 'in_progress'"
                   [class.text-success]="entry.status == 'done'"
                   [class.text-secondary]="entry.status == 'cancelled'"
                ></i>
                {{ entry.status | status }}
            </td>
            <td>{{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}</td>
            <td>
                {{ entry.customer }}
                <span class="text-muted" *ngIf="!entry.customer">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.contact }}
                <span class="text-muted" *ngIf="!entry.contact">Nicht gesetzt</span>
            </td>
            <td>{{ entry.due_date | date: 'dd.MM.yyyy' }}</td>
            <td>
                {{ entry.department }}
                <span class="text-muted" *ngIf="!entry.department">Nicht gesetzt</span>
            </td>
            <td>{{ entry.tasktype }}</td>
        </tr>
        </tbody>
    </table>

    <div class="text-muted" *ngIf="entries?.length == 0">Keine Aufgaben gefunden!</div>
</div>


